// extracted by mini-css-extract-plugin
export default {"home":"SubScripe_home__LUU18","home2":"SubScripe_home2__Wfl0g","main":"SubScripe_main__lnQrH","brmedium":"SubScripe_brmedium__2JsZF"};